export default __webpack_public_path__ + "static/media/element1Card.f205d285.svg";